export default __webpack_public_path__ + "e8f673a3674b3ad41e8fb1de7fa7c492.svg";